import { ErrorHandler, Injectable, Injector, Inject, Component, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import {ApiService} from './shared/api.service';

@Injectable()
export class SwarmErrorHandler implements ErrorHandler {
    constructor(private injector: Injector, private api: ApiService, private zone: NgZone) {}
    snackBar;
    route;
    dialog;
    dialogOpen = false;
    handleError(error) { 
        const httpError = error instanceof HttpErrorResponse;
        if( httpError && (error.status == 200 || (error.url && error.url.indexOf('hooks.slack') !== -1)) ) {
            return;
        }
        this.dialog = this.injector.get(MatDialog);
        this.snackBar = this.injector.get(MatSnackBar);

        const user = this.api.getProp('user');
        let message = '\n\n*User:* ' + user.name;
        message += '\n*Location:* ' + window.location.href;
        message += '\n*Error:* ' + error.name;
        message += '\n*Message:* ' + error.message;
        message += '\n*User Agent:* ' + navigator.userAgent;

        if( httpError ) {
            this.zone.run(() => {
                this.maybeShowMessage(error);
            });
            message += this.addHttpDetails(error);
        } else {
            message += '\n*Trace:* ' + error.stack;
        }
        
        if( this.shouldSend(error, httpError) ) {
            this.send(message);
        }
        console.error('SwarmErrorHandler', error);
    }
    shouldSend(error, httpError) {
        if( httpError && (error.status == 403 && error.error.code == 'rest_cookie_invalid_nonce') ) {
            return false;
        }
        return true;
    }
    addHttpDetails(error) {
        let message = '\n*Status:* ' + error.status;
        message += '\n*StatusText:* ' + error.statusText;
        message += '\n*Request Url:* ' + error.url;
        message += '\n*Error:* ' + JSON.stringify(error.error);
        message += '\n*Request:* ' + JSON.stringify(error.request);
        if (!navigator.onLine) {
            message += '\n*Online:* false';
        }
        return message;
    }
    send(message) {
        this.api.slack({
            text: window.location.hostname,
            attachments: [
                {
                    text: message
                }
            ],
            username: 'SWARM'
        });
    }
    maybeShowMessage(error) {
        if( error.status == 403 && error.error.code == 'rest_cookie_invalid_nonce' && !this.dialogOpen ) {
            this.dialogOpen = true;
            this.api.loggedOut = true;
            let dialogRef = this.dialog.open(LoginDialog, {
                disableClose: true
            });
            dialogRef.afterClosed().subscribe(data => {
                this.dialogOpen = false;
                this.api.loggedOut = false;
            });
        }
        if( error.status == 404 && error.url.indexOf('/wp-json/wp/v2/assignments/') !== -1 && error.error.code == 'rest_post_invalid_id' ) {
            this.snackBar.open('This assignment no longer exists.', 'CLOSE', {duration: 5000});
        }
        let show502 = error.status == 502;
        if( 
            (error.url.indexOf('swarm/v1/slides') && error.response.body.action && error.response.body.action == 'update') ||
            (error.url.indexOf('swarm/v1/assignments') && error.response.body.action && error.response.body.action == 'update') ||
            error.url.indexOf('swarm/v1/publish')
        ) {
            show502 = false;
        }
        if( error.status == 0 || show502 ) {
            this.snackBar.open('We are having trouble connecting...', 'CLOSE', {duration: 5000});
        }
    }
}

@Component({
    selector: 'login-dialog',
    template: `
        <mat-dialog-content>
            <login-component (loginChange)="maybeClose($event)"></login-component>
        </mat-dialog-content>`
})
export class LoginDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any, private ref: MatDialogRef<LoginDialog>) { }
    maybeClose(loggedIn) {
        if( loggedIn ) {
            this.ref.close();
        }
    }
}